import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetMailBatchDetail,
    HttpGetMailBatchDetailParams,
    MailBatchDetailResponse
} from '@/features/mailer/http/mailer.http'
import {PaginationResponse} from '@/types'

export const useMailBatchDetail = (
    params: HttpGetMailBatchDetailParams,
    options?: Omit<UseQueryOptions<MailBatchDetailResponse>, 'queryKey' | 'queryFn'>
) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: params.limit,
        currentPage: params.page
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.MAILER_BATCH_DETAIL, params],
        queryFn: () => httpGetMailBatchDetail(params),
        enabled: !!params.batchId,
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [query.data?.data.length])

    return {...query, persistedPagination}
}
